import script from "./ComboBoxContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComboBoxContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ComboBoxContainer.vue?vue&type=style&index=0&id=6f62754f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f62754f"]])

export default __exports__